export interface FavouriteDataColumn {
  columnName: string;
  columnType: string;
  dataType: string;
  numberOfDecimals: number;
  domain: number;
  domainNode: number;
  codetable: number;
  text: string;
  shortText: string;
  extraText: string;
  selectionType: number;
  levels: number;
  period: number;
  interval: number;
  selectedCode: number;
  aggregationType: AggregationType;
  targetApplication: number;
  targetText: string;
  rollingAveragePeriods: number;
  rollingAverageText: string;
  exposureApplication: number;
  exposureApplicationText: string;
  exposurePercentInc: number;
  urlTemplate: string;
  uomDomain: number;
  sortOrderType: SortOrderType;
  orderBy: ('value' | 'sequence' | 'aggrSequence')[];
  isMultipleSelect?: boolean;
  isHierarchical?: boolean;
  supportsIcon?: boolean;
  supportsColour?: boolean;
  supportsLongDescription?: boolean;
}

export interface FavouriteRowValue {
  value: any;
  code: number;
  sequence: number;
  aggrSequence: string;
  fgColour: number;
  bgColour: number;
  iconUrl: string;
  noExp: boolean;
  noTar: boolean;
}

export interface FavouriteMetaData {
  noExp: boolean;
  noTar: boolean;
}

export interface FavouriteDataCondition {
  conditionNo: number;
  domain: number;
  text: string;
  conditionText: string;
  isNegated: boolean;
  operator: number;
  operator2: number;
  favOperator: number;
  forceExists: boolean;
  exactLevel: boolean;
  valueListOperator: number;
  valueListSeparator: string;
  conditionValues: FavouriteDataConditionValue[];
}

export interface FavouriteDataConditionValue {
  conditionValueNo: number;
  value: any;
  operator: number;
  dbFunction: number;
  periodPredef: number;
}

export interface FavouriteDataConnected {
  favourite: number;
  description: string;
  operator: number;
}

/*
 * Detailed favourite data.
 */
export interface FavouriteDataModel {
  id: number;
  favouriteName: string;
  description: string;
  report: number;
  conditions?: FavouriteDataCondition[];
  connected?: FavouriteDataConnected[];
  errorMessages?: string[];
  maxRows?: number;
  columns: FavouriteDataColumn[];
  rows: FavouriteRowValue[][];
}

export enum AggregationType {
  NotSelected = 0,
  Count = 1,
  Total = 2,
  Average = 3,
  Minimum = 4,
  Maximum = 5,
  DaysSinceLast = 7,
  DaysSinceFirst = 8
}

export enum SortOrderType {
  NotSelected = 0,
  Asc = 1,
  Desc = 2
}

export enum ColumnDataType {
  Interval = 'Interval',
  Integer = 'Integer',
  Float = 'Float',
  Date = 'Date'
}
